var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"search"}},[_c('span',{attrs:{"id":"searched-model"}},[_c('h2',[_vm._v(_vm._s(_vm.search))]),_c('Model',{attrs:{"background":_vm.searchfor.background,"rotationSpeed":0,"transformation":null}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }